import React, { useState, useEffect } from 'react';
import { Event, PageView, ModalView, Timing } from "../GoogleAnalytics";
import Loader from "../Loader/Loader";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import BaseAlertPage from "../LWTriageAlerts/BaseAlertPage";
import FurnaceOnboarding from "./FurnaceOnboarding";
import RetrainFurnaceOnboarding from "./RetrainFurnaceOnboarding";
import ACOnboarding from "./ACOnboarding";
import AirHandlerOnboarding from "./AirHandlerOnboarding";
import HeatPumpOnboarding from './HeatPumpOnboarding';
import SummaryOnboarding from "./SummaryOnboarding";
import  UserFeedbackService  from './../../services/feedback.service';

function OperationalDashboard(props) {
    const {isLoading, currentPartnerId, _isMounted, setActivePath, loggedInOrg, showAllTraining, setShowAllTraining ,customerCount} = props;
    const [feedbackData, setFeedbackData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            if (currentPartnerId) {
                const data = await UserFeedbackService.getFeedbackTableData(currentPartnerId);
                setFeedbackData(data);
            }
        }
        fetchData();
    }, [currentPartnerId]);
    
    return (
        <div sx={(theme) => ({
            [theme.breakpoints.down('md')]: {
                marginLeft: '-225px !important',
            },
        })}>
            <div className='infoPage'>
                <Tabs className="pad-top-20">
                    <TabList className="pad-left-30">
                        <Tab>Summary</Tab>
                        <Tab>Furnace</Tab>
                        <Tab>Retrain Furnace</Tab>
                        <Tab>Air Conditioner</Tab>
                        <Tab>Air Handler</Tab>
                        <Tab>Heat Pump</Tab>
                    </TabList>
                    
                    <TabPanel>
                        <SummaryOnboarding setActivePath={setActivePath} loggedInOrg={loggedInOrg} currentPartnerId={currentPartnerId} showAllTraining={showAllTraining} setShowAllTraining={setShowAllTraining} customerCount ={customerCount} feedbackData={feedbackData}/>
                    </TabPanel>
                    <TabPanel>
                        <FurnaceOnboarding setActivePath={setActivePath} loggedInOrg={loggedInOrg} currentPartnerId={currentPartnerId} showAllTraining={showAllTraining} setShowAllTraining={setShowAllTraining} customerCount ={customerCount} />
                    </TabPanel>
                    <TabPanel>
                        <RetrainFurnaceOnboarding setActivePath={setActivePath} loggedInOrg={loggedInOrg} currentPartnerId={currentPartnerId} showAllTraining={showAllTraining} setShowAllTraining={setShowAllTraining} customerCount ={customerCount} />
                    </TabPanel>
                    <TabPanel>
                        <ACOnboarding setActivePath={setActivePath} loggedInOrg={loggedInOrg} currentPartnerId={currentPartnerId} showAllTraining={showAllTraining} setShowAllTraining={setShowAllTraining} customerCount ={customerCount} />
                    </TabPanel>
                    <TabPanel>
                        <AirHandlerOnboarding setActivePath={setActivePath} loggedInOrg={loggedInOrg} currentPartnerId={currentPartnerId} showAllTraining={showAllTraining} setShowAllTraining={setShowAllTraining} customerCount ={customerCount} />
                    </TabPanel>
                    <TabPanel>
                        <HeatPumpOnboarding setActivePath={setActivePath} loggedInOrg={loggedInOrg} currentPartnerId={currentPartnerId} showAllTraining={showAllTraining} setShowAllTraining={setShowAllTraining} customerCount ={customerCount}  feedbackData={feedbackData}/>
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    )
}

export default OperationalDashboard;